import React from "react";

const SupportLink = ({
  fill = "#ffffff",
  viewBox = "0 0 24 25",
  width = 24,
  height = 28
}) => {
  return (
    <svg viewBox={viewBox} height={height} width={width}>
      <path d="M0,0H24V24H0Z" fill="none" />
      <path
        d="M12,2a10,10,0,0,0,0,20,9.77,9.77,0,0,0,1.44-.1c.78-.12.52.86.56,1.1.64,4,3.79-2.81,4.41-3.33A10,10,0,0,0,12,2Zm.75,16h-1.5V16.5h1.5Zm1.55-5.81-.67.69A2.55,2.55,0,0,0,12.75,15h-1.5v-.38a3,3,0,0,1,.88-2.12l.93-.94A1.5,1.5,0,1,0,10.5,10.5H9a3,3,0,0,1,6,0A2.39,2.39,0,0,1,14.3,12.19Z"
        fill={fill}
      />
    </svg>
  );
};

export default SupportLink;
